import { Card, Grid, Link, Typography } from "@mui/material";
import colors from "../../../colors";
import LocalPhoneIcon from "@mui/icons-material/LocalPhoneOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import React from "react";
import { makeStyles } from "@mui/styles";
import { texts } from "../../../general/texts";

const HelpView = () => {
  const contactOptions = [
    // {
    //   icon: <LocalPhoneIcon  color="warning" />,
    //   name: "Phone",
    //   link: "tel:355-6840-66-657",

    // },
    {
      icon: <WhatsAppIcon color="warning" />,
      name: "WhatsApp",
      link: "https://wa.me/355686021566?text=Pershendetje",
    },
    {
      icon: <EmailIcon color="warning" />,
      name: "Mail",
      link: "mailto:kembimi@easypay.al",
    },
    // {
    //   icon: <InstagramIcon color="warning" />,
    //   name: "Instagram",
    //   link: "https://www.instagram.com/easypay.al/",
    // },
  ];

  const useStyles = makeStyles({
    card: {
      width: "90%",
      padding: 15,
      background: colors.cyan,
      borderRadius: "10px",
    },
    link: {
      fontFamily: "GerberaBold",
      color: colors.darkBlue,
      textDecoration: "none",
      ":hover": {
        textDecorationColor: "#FF8403",
        textDecoration: "underline",
        color: "#FF8403",
      },
    },
    text: {
      color: colors.darkBlue,
      fontFamily: "GerberaMedium",
      textAlign: "left",
    },
    typography: {
      fontSize: "0.9rem",
      fontFamily: "GerberaMedium",
      color: colors.darkBlue,
      textAlign: "left",
    },
    typographyCard: {
      width: "90%",
      padding: 10,
      background: colors.white,
      borderRadius: "10px",
    },
  });

  const classes = useStyles();

  return (
    <Grid
      container
      item
      md={12}
      xs={12}
      justifyContent={"space-between"}
      alignItems={"center"}
      flexDirection={"column"}
      rowGap={1}
    >
      <Card elevation={0} className={classes.typographyCard}>
        <Typography className={classes.typography}>
        {texts["message-exchange-contact"]}
        </Typography>
      </Card>
      {contactOptions.map((option, index) => (
        <Card key={index} elevation={0} className={classes.card}>
          <Link href={option.link} target="_blank" className={classes.link}>
            <Grid container item md={12} xs={12} alignItems={"center"}>
              <Grid container item md={1} xs={1}>
                {option.icon}
              </Grid>
              <Grid container item md={2} xs={2}>
                <Typography className={classes.text}>{option.name}</Typography>
              </Grid>
              <Grid
                container
                item
                md={9}
                xs={9}
                justifyContent={"right"}
                alignItems={"center"}
              >
                <KeyboardArrowRightIcon color="warning" />
              </Grid>
            </Grid>
          </Link>
        </Card>
      ))}
    </Grid>
  );
};

export default HelpView;

{
  /* <Typography
          sx={{
            fontSize: "1rem",
            fontFamily: "GerberaLight",
            color: colors.darkBlue,
          }}
        >
          Për këmbim valutor me kursin e shfaqur ose për kurs preferencial për
          shuma të mëdha, kontaktoni në
          <Link
            href="mailto:kembimi@easypay.al"
            target="_blank"
            style={{
              fontFamily: "GerberaBold",
              color: colors.darkBlue,
              textDecoration: "none",
              "&:hover": {
                textDecorationColor: "#FF8403",
                textDecoration: "underline",
                color: "#FF8403",
              },
            }}
          >
            {" "}
            kembimi@easypay.al
          </Link>
          . Këmbimi kryhet në llogarinë tuaj bankare.
        </Typography> */
}
